'use-strict';

import jQuery from 'jquery';

// ==================== "SDK" ====================
import CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
import BiometricsIds from './Interfaces/Responses/BiometricIds';
import {GeneralInformation, NoCamera} from './Interfaces/Settings/GeneralInfo';

import $ from 'jquery';

import Errors from './Interfaces/Settings/Errors';
// ===============================================

let sdkSettings = {};
let done;

export const iniciarFluxo = (settings, complete) => {
  sdkSettings = settings;
  done = complete;
  let vazio = false;

  // Checando se o objeto tem algum atributo vazio.
  for (const key of Object.keys(sdkSettings)) {
    if (!sdkSettings[key]) {
      console.log(`A key ${key} tá vazia!`);
      vazio = true;
      break;
    }
  }

  if (vazio) return;

  gerarCredencial();
};

// Gera credencial de acesso. Deve ser feita no backend
const gerarCredencial = () => {
  const data = jQuery.param({
    user: sdkSettings.user,
    pass: sdkSettings.pass,
  });

  jQuery.support.cors = true;
  jQuery.ajax({
    type: 'POST',
    url: sdkSettings.fcvarUrlbase + '/facecaptcha/service/captcha/credencial',
    data: data,
    crossDomain: true,
    async: true,
    headers: {
      'cache-control': 'no-cache',
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'Access-Control-Allow-Origin': '*',
    },
    success: (data) => {
      // ex: {"token":"V-zI5XK4bnlNVPSByxMeR9cHFpvAcdBypEFLU649aEQ","expires":"24/01/2019 22:51:20"}
      gerarAppkey(data);
    },
    error: (xhr, textStatus) => {
      console.log(textStatus);
      console.log(xhr);
    },
  });
};

// Gera appkey de acesso. Deve ser feita no backend.
const gerarAppkey = (chavePrivada) => {
  const data = jQuery.param({
    user: sdkSettings.user,
    token: JSON.stringify(chavePrivada),
    cpf: sdkSettings.cpf,
    nome: sdkSettings.nome,
    nascimento: sdkSettings.nascimento,
  });

  jQuery.support.cors = true;
  jQuery.ajax({
    type: 'POST',
    url: sdkSettings.fcvarUrlbase + '/facecaptcha/service/captcha/appkey',
    data: data,
    crossDomain: true,
    async: true,
    headers: {
      'cache-control': 'no-cache',
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'Access-Control-Allow-Origin': '*',
    },
    success: (data) => {
      // ex: {"appkey":"HS256.payload.secret"}
      const appkey = data.appkey;
      // inicializa captura dos desafios.
      startCapture(appkey, done);
    },
    error: (xhr, textStatus) => {
      console.log(textStatus);
      console.log(xhr);
    },
  });
};

// ==================== "SDK" ====================
let fcvarUrlbase = 'https://comercial.certiface.com.br:443';
let appkey = '';

let fcvarChkey;
let fcvarChallenge = '';
let fcvarTime;
let fcvarSnapFrequenceInMillis = 0;

let fcvarInChallenge = false;
let fcvarIntervalSnap;
let fcvarIntervalChallege;
let fcvarIntervalTimer;

// foto
let fcvarCurCha;
let fcvarSnaps = '';
let fcvarFirstSnap = '';

// crop
let canvasW = 320;
let canvasH = 480;

let canContinue = true;

export const iniciarCamera = async () => {
  // get video element
  let video = document.getElementById('player');
  video.setAttribute('autoplay', '');
  video.setAttribute('muted', '');
  video.setAttribute('playsinline', '');

  // ajusta as configurações de video
  let constraints = {
    audio: false,
    video: {
      width: {exact: 640},
      height: {exact: 480},
      facingMode: '',
    },
  };

  // se mobile, ajusta configurações de video para mobile
  if (isMobile()) {
    constraints = {
      audio: false,
      video: {
        width: {exact: 1280},
        height: {exact: 720},
        facingMode: 'user', // câmera frontal
      },
    };
  }

  navigator.mediaDevices
    .getUserMedia(constraints)
    .then((stream) => {
      if (stream.active) {
        video.srcObject = stream;

        // exibe botão INICIAR
        $('#divButton').fadeIn();
        $('#divMsg').fadeIn(700, () => {
          window.setTimeout(() => {
            $('#divMsg').fadeOut(700, () => {});
          }, 1000);
        });
      }
    })
    .catch((err) => {
      canContinue = false;
      addMessage('No camera! ' + err);
      Swal.fire({
        title: NoCamera.title_noCamera,
        text: NoCamera.subTitle_noCamera,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then(() => window.location.reload());
    });
};

const stopCameraInternal = (stream) =>
  stream.getVideoTracks().forEach((track) => track.stop());

// inicia captura dos desafios.
const startCapture = (appKeyParameter, complete) => {
  appkey = appKeyParameter;
  done = complete;
  if (!canContinue) {
    Swal.fire({
      title: NoCamera.title_noCamera,
      text: NoCamera.subTitle_noCamera,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
    }).then(() => window.location.reload());
  }

  // esconde o botão e exibe loader
  $('#divButton').fadeOut();
  $('#divLoader').fadeIn();

  $('#spanMsg').text(GeneralInformation.gettingStarted);
  $('#divMsg').fadeIn(1000, () => startChallenge(''));
};

// Busca novos desafios
const startChallenge = (p) => {
  // let data = "?nc=" + new Date().getTime() + "&appkey=" + appkey + "&p=" + p;
  const data = `?nc=${new Date().getTime()}&appkey=${appkey}&p=${p}`;

  $.support.cors = true;
  $.ajax({
    type: 'POST',
    // url: fcvarUrlbase + "/facecaptcha/service/captcha/challenge",
    url: `${fcvarUrlbase}/facecaptcha/service/captcha/challenge`,
    data: data,
    crossDomain: true,
    async: true,
    headers: {
      'cache-control': 'no-cache',
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'Access-Control-Allow-Origin': '*',
    },
    success: (response) => {
      try {
        // resposta da requisição dos desafios
        response = JSON.parse(decChData(response));

        fcvarChkey = response.chkey; // chave da requisição
        fcvarChallenge = response.challenges; // desafios da requisição   [2]
        fcvarTime = response.totalTime; // tempo total de todos os desafios (seg)   [8]
        fcvarSnapFrequenceInMillis = response.snapFrequenceInMillis; // tempo para cada snap (mseg)  [1990]

        $('#divLoader').fadeOut(700);
        $('#divMsg').fadeOut(700, () => {
          // prepara os desafios
          prepareChallenge();
        });
      } catch (e) {
        console.log(e);
      }
    },
    error: (jqXHR, textStatus, errorThrown) => {
      console.log('ERROR');
      fcvarInChallenge = true;

      Swal.fire({
        title: 'errorStartChallengeTitle',
        text: 'errorStartChallengeMsg',
        confirmButtonText: 'btnTryAgain',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then(() => window.location.reload());
    },
  });
};

// Preparar desafios
const prepareChallenge = () => {
  // Intervalo de captura de image do video
  fcvarIntervalSnap = setInterval(() => {
    snapTick();
  }, fcvarSnapFrequenceInMillis);

  // aguarda fcvarTime em segundos para finalizar os desafios
  fcvarIntervalTimer = setInterval(() => {
    clearInterval(fcvarIntervalSnap);
    clearInterval(fcvarIntervalChallege);
    clearInterval(fcvarIntervalTimer);

    $('#divMsg').fadeOut(700, () => stopChallenge());
  }, fcvarTime * 1000);

  // exibe os desafios na tela
  showChallengeTick(fcvarChallenge, 0);
};

// Exibir desafios
const showChallengeTick = (challenges, i) => {
  fcvarCurCha = challenges[i];

  $('#imgMsg').attr('src', '');
  $('#spanMsg').text('');
  $('#divMsg').hide();
  $('#divSorriso').hide();

  // atribui imagem Desafio (msg)
  $('#imgMsg').attr('src', 'data:image/png;base64,' + challenges[i].mensagem);
  $('#divMsg').fadeIn();
  $('#divMsg').fadeOut(challenges[i].tempoEmSegundos * 1000); // exibe a mensagem do desafio pelo periodo de challenges[i].tempoEmSegundos

  // atribui imagem Desafio (emojji)
  $('#imgChallenge').attr(
    'src',
    'data:image/png;base64,' + challenges[i].tipoFace.imagem,
  );
  $('#divSorriso').fadeIn();
  $('#divSorriso').fadeOut(challenges[i].tempoEmSegundos * 1000); // exibe o emojji do desafio pelo periodo de challenges[i].tempoEmSegundos

  fcvarIntervalChallege = setTimeout(() => {
    // Proximo desafio. Recursive
    showChallengeTick(challenges, ++i);
  }, challenges[i].tempoEmSegundos * 1000);
};

// prepara captura de imagem
const snapTick = () => {
  let snapb64 = snap();
  let snaps = [];

  if (fcvarFirstSnap === '') {
    fcvarFirstSnap = snapb64;
  }

  // necessario adicionar o codigo do tipoFace entre o 'data:image/jpeg' e o snapb64
  snaps = snapb64.split('data:image/jpeg;base64,');
  snapb64 =
    'data:image/jpeg;base64,' +
    snaps[0] +
    'type:' +
    fcvarCurCha.tipoFace.codigo +
    ',' +
    snaps[1];

  fcvarSnaps += snapb64;
};

// captura imagem da câmera
const snap = () => {
  let video = document.querySelector('video');
  let canvas = document.getElementById('fc_canvas');
  let ctx = canvas.getContext('2d');

  ctx.canvas.width = 320;
  ctx.canvas.height = 480;

  let ratio = video.videoWidth / video.videoHeight;
  let widthReal = 0,
    heightReal = 0;

  let startX = 0,
    startY = 0;

  if (ratio >= 1) {
    // paisagem
    widthReal = video.videoHeight / 1.5;
    heightReal = video.videoHeight;

    startX = (video.videoWidth - widthReal) / 2;
    startY = 0;
  } else {
    // retrato
    ratio = video.videoHeight / video.videoWidth;

    // verifica proporção
    if (ratio > 1.5) {
      widthReal = video.videoWidth;
      heightReal = video.videoWidth * 1.5;

      startX = 0;
      startY = (video.videoHeight - heightReal) / 2;
    } else {
      widthReal = video.videoHeight / 1.5;
      heightReal = video.videoHeight;

      startX = (video.videoWidth - widthReal) / 2;
      startY = 0;
    }
  }

  // crop image video
  ctx.drawImage(
    video,
    startX,
    startY,
    widthReal,
    heightReal,
    0,
    0,
    ctx.canvas.width,
    ctx.canvas.height,
  );

  let img = new Image();
  img.src = canvas.toDataURL('image/jpeg');

  return img.src;
};

// finaliza desafios
const stopChallenge = () => {
  $('#imgMsg').attr('src', '');
  $('#divLoader').fadeIn();
  $('#spanMsg').text(GeneralInformation.wait);
  $('#divMsg').fadeIn();

  // encripta as imagens
  const data = $.param({
    appkey: appkey,
    chkey: fcvarChkey,
    images: encChData(fcvarSnaps),
  });
  jQuery.support.cors = true;
  jQuery.ajax({
    type: 'POST',
    url: `${fcvarUrlbase}/facecaptcha/service/captcha?nc=${new Date().getTime()}`,
    // fcvarUrlbase +
    // "/facecaptcha/service/captcha" +
    // "?nc=" +
    // new Date().getTime(),
    crossDomain: true,
    async: true,
    headers: {
      'cache-control': 'no-cache',
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    data: data,
    success: (response) => {
      $('#divLoader').fadeOut();
      $('#divMsg').fadeOut();

      response.snap = fcvarFirstSnap;
      if (response.valid) {
        // passou no prova de vida e biometria
        // checkAnimStart();
        onFinishFaceCaptcha(response);
      } else {
        // reprovou no prova de vida ou na biometria
        // crossAnimStart(response);
        onFinishFaceCaptcha(response);
      }

      // informa resltados
      // onFinishFaceCaptcha(response);
    },
    error: (jqXHR, textStatus, errorThrown) => {
      $('#divLoader').fadeOut();
      Swal.fire({
        title: Errors.errorStopChallengeTitle,
        text: Errors.errorStopChallengeMsg,
        confirmButtonText: 'btnTryAgain',
        allowOutsideClick: true,
        allowEscapeKey: false,
        allowEnterKey: true,
      }).then(() => window.location.reload());
    },
    beforeSend: (xhr) => {},
  });
};
// exibe mensagem de sucesso
const checkAnimStart = () => {
  Swal.fire({
    title: GeneralInformation.finishedTitle,
    text: GeneralInformation.finishedMsg,
    allowOutsideClick: true,
    allowEscapeKey: false,
    allowEnterKey: true,
  }).then(() => {});
};

// exibe informação de insucesso
const crossAnimStart = (responseCaptcha) => {
  const codID = responseCaptcha.codID;
  const msg = BiometricsIds[codID] || BiometricsIds.biometricCodID;

  Swal.fire({
    title: GeneralInformation.infoTitle,
    text: msg,
    allowOutsideClick: true,
    allowEscapeKey: false,
    allowEnterKey: true,
  }).then(() => window.location.reload());
};

// use este metodo para informar o backend
const onFinishFaceCaptcha = (response) => {
  console.log('onFinishFaceCaptcha');
  console.log(response);

  done = true;

  /*
    Ex:
    $.ajax({
        type: 'POST',
        url: '/result',
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(response),
        dataType: 'json',
        success: function(res){
            // sucesso
        },
        error: function(res){
            // ops!
        }
    });
    */
};

const addMessage = (msg) => {
  console.log(msg);
};

// verifica se o navegador é um dispositivo mobile
const isMobile = () => {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    )
  ) {
    return true;
  }
  return false;
};

/* SECURITY */
const padMsg = (source) => {
  let paddingChar = ' ';
  let size = 16;
  let x = source.length % size;
  let padLength = size - x;
  for (let i = 0; i < padLength; i++) source += paddingChar;
  return source;
};

const padKey = (source) => {
  if (source.length > 16) {
    return source.substring(0, 16);
  }
  return padMsg(source);
};

const decChData = (data) => {
  const key = CryptoJS.enc.Latin1.parse(padKey(appkey));
  const iv = CryptoJS.enc.Latin1.parse(
    padKey(appkey.split('').reverse().join('')),
  );
  let decripted2 = CryptoJS.enc.Utf8.stringify(
    CryptoJS.AES.decrypt(data, key, {
      iv: iv,
      padding: CryptoJS.pad.NoPadding,
      mode: CryptoJS.mode.CBC,
    }),
  );
  decripted2 = decripted2.substring(0, decripted2.lastIndexOf('}') + 1);
  decripted2 = decripted2.trim();
  return decripted2;
};

const encChData = (data) => {
  const key = CryptoJS.enc.Latin1.parse(padKey(appkey));
  const iv = CryptoJS.enc.Latin1.parse(
    padKey(appkey.split('').reverse().join('')),
  );
  const result = CryptoJS.AES.encrypt(padMsg(data), key, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  }).toString();
  return encodeURIComponent(result);
};

export {startCapture, isMobile};
